import React from "react";
import { getIsConstantContactIntegrationAccessible } from "../../../../../../helpers/integrations";

export function Title({ isEnabled, onToggle }) {
  const isIntegrationAccessible = getIsConstantContactIntegrationAccessible();

  return (
    <div className="setting-setion m-b-10">
      <div className="membership-title">
        Sync Constant Contact
        <div className="memberRightActions">
          <span className="switch-text"></span>
          <label className="setting-switch pull-right">
            <input
              type="checkbox"
              name="sync"
              id="sync"
              disabled={!isIntegrationAccessible}
              checked={isEnabled && isIntegrationAccessible}
              onChange={onToggle}
            />
            <span className="setting-slider"></span>
          </label>
        </div>
      </div>
    </div>
  );
}
